module.exports = __webpack_public_path__ + "img/2.81c2bbf3.png";